import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿CUÁNDO RECIBO LOS LIBROS?',
  answer: 'Inmediatamente. Una vez que realizas el pago, recibes todo el material en tu correo electrónico en cuestión de minutos. Sin esperas, sin envíos físicos.'
}, {
  question: '¿DÓNDE PUEDO COMPRAR LOS MATERIALES EN MI CIUDAD?',
  answer: 'Si compras hoy, recibirás una lista exclusiva de proveedores por país para que sepas exactamente dónde comprar y qué comprar, al mejor precio posible.'
}, {
  question: '¿CÓMO PUEDO LEER EL LIBRO DIGITAL?',
  answer: 'Puedes leerlo directamente desde tu celular, tablet o computador. También puedes imprimir las secciones que consideres más importantes para tenerlas a la mano mientras practicas.'
}, {
  question: '¿PUEDO COMPRAR EL LIBRO SI SON LAS 3:00 AM?',
  answer: 'Sí. Puedes comprar en cualquier momento del día o la noche, los 7 días de la semana. Mientras veas la promoción activa, puedes acceder al precio especial.'
}, {
  question: '¿ES SEGURO COMPRAR EN ESTE SITIO WEB?',
  answer: 'Totalmente. Tu compra está protegida por Shopify Payments y cuentas con una garantía de 120 días. Aceptamos todas las tarjetas principales con encriptación segura.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-[var(--bg-dark)] py-8 md:py-12 px-4" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[var(--text-light)] mb-6 md:mb-8 text-center reveal" data-id="element-107">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-108">
          {faqs.map((faq, index) => <div key={index} className="bg-[var(--bg-card)] rounded-lg border-l-4 border-[var(--accent-orange)] overflow-hidden reveal" data-delay={index + 1} data-id="element-109">
              <button onClick={() => toggleFAQ(index)} className="w-full p-3 md:p-4 flex items-center justify-between gap-4 text-left hover:bg-[var(--bg-dark)] transition-colors duration-200" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-110">
                <span className="text-sm md:text-base lg:text-lg font-bold text-[var(--text-light)] uppercase" data-id="element-111">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 transition-transform duration-200" style={{
              transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
            }} data-id="element-112">
                  <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6 text-[var(--accent-orange)]" aria-hidden="true" data-id="element-113" />
                </div>
              </button>

              <AnimatePresence initial={false} data-id="element-114">
                {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-115">
                    <div className="px-3 md:px-4 pb-3 md:pb-4" data-id="element-116">
                      <p className="text-sm md:text-base lg:text-lg text-[var(--text-gray)] leading-relaxed" data-id="element-117">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}